/**
 * CloudLedger Frontend Entry Point
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from "@tanstack/react-query";
import App from "./App";
import "./styles/index.css";

// Global 401 handler - auto logout when token expires
const handle401 = (error: unknown) => {
    // Check if it's a 401 response
    if (
        error &&
        typeof error === "object" &&
        "status" in error &&
        (error as { status: number }).status === 401
    ) {
        // Clear token and reload to login page
        localStorage.removeItem("cloudledger_token");
        window.location.reload();
    }
};

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            retry: (failureCount, error) => {
                // Don't retry on 401
                if (
                    error &&
                    typeof error === "object" &&
                    "status" in error &&
                    (error as { status: number }).status === 401
                ) {
                    return false;
                }
                return failureCount < 1;
            },
        },
    },
    queryCache: new QueryCache({
        onError: handle401,
    }),
    mutationCache: new MutationCache({
        onError: handle401,
    }),
});

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>
);
